'use es6';

import http from 'hub-http/clients/apiClient';
import httpRxjs from 'hub-http-rxjs/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getEarlyRequesterResultPromise from '../earlyRequester/getEarlyRequesterResultPromise';
const URI = 'blog-settings/v1/blogs';
export default {
  createLanguageVariation({
    masterLanguage,
    contentGroupId,
    language
  }) {
    return httpRxjs.post(`${URI}/${contentGroupId}/create-language-variation`, {
      data: {
        language,
        masterLanguage
      }
    });
  },

  fetchBlogUsage() {
    return getEarlyRequesterResultPromise({
      name: 'blogs-usage',
      retryRequester: () => http.get(`${URI}/${PortalIdParser.get()}/usage`)
    });
  }

};